'use strict';

exports.__esModule = true;

var _styledSystem = require('styled-system');

exports["default"] = (0, _styledSystem.compose)(_styledSystem.alignItems, _styledSystem.alignContent, _styledSystem.justifyItems, _styledSystem.justifyContent, _styledSystem.flexWrap, _styledSystem.flexDirection);
module.exports = exports['default'];